import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.title = 'Press Releases';
moduleConfig.singleItemTitle = 'Press Release';
moduleConfig.url = 'press-releases';
moduleConfig.moduleType = {
    listing: 'block',
    view: 'block'
};


moduleConfig.bulkActions = [
    {
        displayName: "Enable Selected",
        value: "enabled"
    },
    {
        displayName: "Disable Selected",
        value: "disabled"
    }
];


export default moduleConfig;